import { render, staticRenderFns } from "./StatusApproval.vue?vue&type=template&id=28924c12&"
import script from "./StatusApproval.vue?vue&type=script&lang=js&"
export * from "./StatusApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports